import { createSelector } from 'reselect';

import { StoreState } from '../index';
import { JobsState } from './jobs.types';
import { Job } from '../job/job.types';
import { comparisonSelector } from '../comparison/comparison.selectors';

export const jobsSelector = (state: StoreState) => state.jobs;

export const jobsByIdSelector = createSelector<StoreState, JobsState, Record<string, Job>>(
  jobsSelector,
  jobs => jobs.reduce((acc, job) => ({ ...acc, [job.job_id]: job }), {})
);

export const jobsDoneSelector = createSelector(jobsSelector, (jobs) =>
  jobs.sort(
    (jobA: Job, jobB: Job) =>
      new Date(jobB.updated_at || jobB.created_at).getTime() - new Date(jobA.updated_at || jobA.created_at).getTime()
  )
);

export const metricJobsSelector = createSelector(
  comparisonSelector,
  (comparison) => comparison.metricJobs
);

// POGs deep-linked by job_id that the aggregated jobs page did not contain. They are listed
// under their own "Seed POG" section instead of the store's previous POG versions.
export const seedJobsDoneSelector = createSelector(jobsDoneSelector, (jobs) =>
  jobs.filter((job: Job) => job.loadedOutOfList)
);

export const listedJobsDoneSelector = createSelector(jobsDoneSelector, (jobs) =>
  jobs.filter((job: Job) => !job.loadedOutOfList)
);